<template>
  <s-wrapper :background-color="backgroundColor">
    <b-container>
      <s-navigation aria-label="breadcrumb">
        <s-navigation-items>
          <s-navigation-item v-for="item in items" :key="item.text">
            <router-link v-if="item.link" :to="item.link">
              {{ item.text }}
            </router-link>
            <s-navigation-text v-else>
              {{ item.text }}
            </s-navigation-text>
          </s-navigation-item>
        </s-navigation-items>
      </s-navigation>
    </b-container>
  </s-wrapper>
</template>

<script>
import {
  SNavigation,
  SNavigationItem,
  SNavigationItems,
  SNavigationText,
  SWrapper
} from "./styles";

export default {
  name: "AppBreadcrumb",
  components: {
    SNavigation,
    SNavigationItem,
    SNavigationItems,
    SNavigationText,
    SWrapper
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    backgroundColor: {
      type: String,
      default: "#ffffff"
    }
  }
};
</script>
